export class PayrollInit {
  static readonly type = '[Payroll] Init';
  constructor() { }
}

export class LoadConfiguration {
  static readonly type = '[Payroll] Load Configutation';
  constructor() { }
}

export class LoadContractors {
  static readonly type = '[Payroll] Load Contractors';
  constructor() { }
}

export class PayContractor {
  static readonly type = '[Payroll] Add Payment';
  constructor(public payload: any) { }
}

export class UpdatePayment {
  static readonly type = '[Payroll] Update Payment';
  constructor(public paymentId: string, public payload: any) { }
}

export class UpdateContractorPayrollConfiguration {
  static readonly type = '[Payroll] Update Contractor Payroll Configuration';
  constructor(public config: any) { }
}
